import { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  ComposedChart as ReComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

import { Tooltip } from "./Tooltip";
import { COLORS } from "../../theme/colors";
import { maxValue } from "./DoubleBarChart";
import { TooltipContent } from "./TooltipContent";
import { nFormatter } from "../../services";

export const ComposedChart = ({ chartData, bars, line, period, height, top, dateDiff }) => {
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  useEffect(() => {
    setTimeout(() => {
      const tags = document.getElementsByClassName("estimated-bar");
      if (tags.length) {
        for (const tag of tags) {
          tag.setAttribute("stroke", COLORS.darks[0][100]);
          tag.setAttribute("stroke-dasharray", 3);
        }
      }
    }, 800);
  }, []);

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReComposedChart
        data={chartData}
        margin={{
          top: top || 20,
          bottom: 5,
        }}
      >
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <XAxis dataKey="x" tickLine={false} />
        <YAxis
          yAxisId="left"
          tickLine={false}
          axisLine={false}
          unit={currencySymbol}
          domain={[0, maxValue]}
          tickFormatter={nFormatter}
        />
        <YAxis
          yAxisId="right"
          tickLine={false}
          orientation="right"
          axisLine={false}
          unit="%"
          domain={[0, maxValue]}
          stroke={COLORS.yellow}
        />
        <Tooltip
          chartData={chartData}
          wrapperStyle={{ outline: "none" }}
          content={<TooltipContent period={period} dateDiff={dateDiff} />}
        />
        {bars.map((bar, i) => (
          <Bar
            key={i}
            yAxisId="left"
            dataKey={bar.dataKey}
            stackId="a"
            fill={bar.fill}
            barSize={20}
            unit={bar.unit || undefined}
          />
        ))}
        <Bar
          className="estimated-bar"
          dataKey="estimated"
          yAxisId="left"
          stackId="a"
          fill={COLORS.darks[0][10]}
        />
        <Line
          yAxisId="right"
          type="monotone"
          dataKey={line.dataKey}
          stroke={line.stroke}
          unit={line.unit}
          dot={{ stroke: "white", fill: COLORS.yellow, strokeWidth: 2, r: 4 }}
          chartType="hide"
        />
      </ReComposedChart>
    </ResponsiveContainer>
  );
};
